'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.normalizeToNull = exports.coalesceArray = exports.toArray = undefined;

var _ramda = require('ramda');

var toArray = function toArray(alo) {
    return Array.prototype.slice.call(alo);
};
var coalesceArray = (0, _ramda.compose)(toArray, (0, _ramda.when)(_ramda.isNil, (0, _ramda.always)([])));
var normalizeToNull = (0, _ramda.when)((0, _ramda.either)((0, _ramda.equals)(''), _ramda.isNil), (0, _ramda.always)(null));

exports.toArray = toArray;
exports.coalesceArray = coalesceArray;
exports.normalizeToNull = normalizeToNull;